<template>
  <div class="contents">
    <div class="d-flex section-title-with-back" v-if="id">
      <img src="@/assets/images/Icon awesome-pen.png" alt="" width="27.3" height="25.2" />
      <p class="title-bk">先生編集</p>
    </div>
    <div class="d-flex section-title-with-back" v-else>
      <img src="@/assets/images/Icon awesome-plus-circle.png" alt="" width="25" height="25" />
      <p class="title-bk">先生登録</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: id ? 'teacher-id-edit' : 'teacher-add', params: id ? { id } : {} }">
        戻る
      </router-link>
    </div>
    <div class="container">
      <table class="table">
        <tbody>
          <tr>
            <th scope="row" width="30%">以下の内容で登録しますか？</th>
            <td />
          </tr>
          <tr>
            <th scope="row">法人名（法人ID）</th>
            <td>{{ currentCorporationDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">ブランド名（ブランドID）</th>
            <td>{{ currentBrandDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">先生ID</th>
            <td>{{ currentTeacher.uid }}</td>
          </tr>
          <tr>
            <th scope="row">先生名</th>
            <td>{{ currentTeacher.name }}</td>
          </tr>
          <tr>
            <th scope="row">先生名（フリガナ）</th>
            <td>{{ currentTeacher.nameReading }}</td>
          </tr>
          <tr>
            <th scope="row">生年月</th>
            <td>{{ currentTeacherBirthday }}</td>
          </tr>
          <tr>
            <th scope="row">性別</th>
            <td>{{ currentTeacherGender }}</td>
          </tr>
          <tr>
            <th scope="row">国籍</th>
            <td>{{ currentTeacherNationality }}</td>
          </tr>
          <tr>
            <th scope="row">雇用形態</th>
            <td>{{ currentTeacherEmploymentStatus }}</td>
          </tr>
        </tbody>
      </table>
      <div class="text-center">
        <button type="button" class="btn-confirm" @click="confirmRevised">修正</button>
        <button type="button" class="btn-red" @click="confirmSaved" :disabled="isLoading">登録</button>
      </div>
      <PopUpHolder
        ref="popup_holder"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="一覧に戻る"
        @greenClick="popupConfirmed"
      >
        <template v-slot:header v-if="id">先生編集</template>
        <template v-slot:header v-else>先生登録</template>
        <template v-slot:body v-if="id">先生の登録情報の編集が完了しました！</template>
        <template v-slot:body v-else>先生の登録が完了しました！</template>
      </PopUpHolder>
      <b-alert variant="danger" v-show="errorMessage" dismissible show>{{ errorMessage }}</b-alert>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import store from '@/store/index.js';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import {
  basicFieldPresent,
  basicBirthday,
  basicCorporationNameIdPresent,
  basicBrandNameIdPresent,
} from '@/presenters/fields';

export default {
  props: {
    id: {
      type: [String, Number],
      required: false,
    },
  },
  components: {
    PopUpHolder,
  },
  data() {
    return {
      errorMessage: null,
      isLoading: false,
    };
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      if (store.getters['teacher/existsUpdateRequiredParams']) {
        store.dispatch('teacher/fetchTeacher', routeTo.params.id).then(() => {
          next();
        });
      } else {
        next({ name: 'teacher-id-edit', params: { id: routeTo.params.id } });
      }
    } else {
      if (store.getters['teacher/existsRegistrationRequiredParams']) {
        next();
      } else {
        next({ name: 'teacher-add' });
      }
    }
  },
  computed: {
    currentTeacher() {
      if (this.teacher.editingTeacher) {
        return this.teacher.editingTeacher;
      } else {
        return this.teacher.teacher;
      }
    },
    currentCorporationDisplay() {
      return basicCorporationNameIdPresent(this.currentTeacher.corporation);
    },
    currentBrandDisplay() {
      return basicBrandNameIdPresent(this.currentTeacher.brand);
    },
    currentTeacherBirthday() {
      return basicBirthday(this.currentTeacher.yearOfBirth, this.currentTeacher.monthOfBirth);
    },
    currentTeacherGender() {
      if (this.currentTeacher.gender) {
        return basicFieldPresent(this.getGenderById(this.currentTeacher.gender.id), 'name');
      }
      return basicFieldPresent(this.getGenderById(this.currentTeacher.genderId), 'name');
    },
    currentTeacherEmploymentStatus() {
      if (this.currentTeacher.employmentStatus) {
        return basicFieldPresent(this.getEmploymentStatusById(this.currentTeacher.employmentStatus.id), 'name');
      }
      return basicFieldPresent(this.getEmploymentStatusById(this.currentTeacher.employmentStatusId), 'name');
    },
    currentTeacherNationality() {
      if (this.currentTeacher.nationality) {
        return basicFieldPresent(this.getCountryById(this.currentTeacher.nationality.id), 'companyjp');
      }
      return basicFieldPresent(this.getCountryById(this.currentTeacher.nationalityId), 'companyjp');
    },
    ...mapState(['teacher']),
    ...mapGetters('country', ['getCountryById']),
    ...mapGetters('gender', ['getGenderById']),
    ...mapGetters('employment_status', ['getEmploymentStatusById']),
  },
  methods: {
    confirmRevised() {
      if (this.id) {
        // This path is for Editing existing Teacher flow
        this.$logger.debug('Need revise, go back to ID ' + this.id);
        this.$router.push({ name: 'teacher-id-edit', params: { id: this.id } });
      } else {
        // This path is for Adding new Teacher flow
        this.$logger.debug('Need revise, go back');
        this.$router.push({ name: 'teacher-add' });
      }
    },
    confirmSaved() {
      this.$logger.debug('Finished Editing: ' + JSON.stringify(this.currentTeacher));
      if (this.id) {
        // This path is for Editing existing Teacher flow
        this.finishEditingTeacher(this.id).then(
          (response) => {
            this.$logger.debug('Show success popup ' + response);
            this.$refs['popup_holder'].show();
          },
          (error) => {
            this.errorMessage = error;
            this.$logger.debug('Error ' + error);
          }
        );
      } else {
        this.isLoading = true;
        // This path is for Adding new Teacher flow
        this.finishEditingTeacher().then(
          (response) => {
            this.$logger.debug('Show success popup ' + response);
            this.$refs['popup_holder'].show();
          },
          (error) => {
            this.isLoading = false;
            this.errorMessage = error;
            this.$logger.debug('Error ' + error);
          }
        );
      }
    },
    popupConfirmed() {
      this.$logger.debug('Popup done');
      this.$router.push({ name: 'teacher' });
    },
    ...mapActions('teacher', ['finishEditingTeacher']),
  },
};
</script>

<style scoped>
.btn-confirm {
  margin-left: 0px;
}
</style>
